import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addCentre,
  getCentres,
  getCentre,
  editCentre,
  deleteCentre,
  getAllCentres
} from "../../store/actions/centre_action";
import { SEARCH_TERMS } from "../enums/centres_enum";
// Get All Data
export const useAllCentres = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.centre);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteCentre(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getCentres({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getCentres({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getCentres({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleCentre = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.centre);
  useEffect(() => {
    dispatch(getCentre(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateCentre = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addCentre(data));
  };
  return [addData];
};
export const useUpdateCentre = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editCentre(id, data));
  };
  return [updateData];
};

export const useSelectAllCentre = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.centre);
    useEffect(() => {
      dispatch(getAllCentres());
    }, []);
    return [data];
  };